import { render } from "./g-payment_stripe-sofort.vue?vue&type=template&id=37b0ab6e&ts=true"
import script from "./g-payment_stripe-sofort.vue?vue&type=script&lang=tsx"
export * from "./g-payment_stripe-sofort.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__